import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mark } from "./Mark";
import { EASE } from "./Motion";

export const Loader = () => {
  const [year, setYear] = useState(1981);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const iv = setInterval(() => setYear((y) => (y >= 2026 ? 2026 : y + 1)), 26);
    const t = setTimeout(() => setDone(true), 1650);
    return () => {
      clearInterval(iv);
      clearTimeout(t);
    };
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="intro-loader"
          className="fixed inset-0 z-[80] flex flex-col items-center justify-center bg-[#0a0b0d] text-[#f5f3ef]"
          exit={{ clipPath: "inset(0% 0% 100% 0%)" }}
          initial={{ clipPath: "inset(0% 0% 0% 0%)" }}
          transition={{ duration: 1, ease: EASE }}
        >
          <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, ease: EASE }}>
            <Mark className="h-20 w-auto" />
          </motion.div>
          <div className="mt-8 font-mono text-xs tracking-[0.4em] text-[#c8a97e]">EST. {year}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
